/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Timing_Errors_OptionInputs */



/**
* | output |
* | --- |
* | "Timing Errors" |
*
* @param {Error_Nav_Timing_Errors_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_timing_errors_option = /** @type {((inputs?: Error_Nav_Timing_Errors_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Timing_Errors_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreurs de synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitfehler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errori di temporizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибки синхронизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Errores de sincronización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("计时误差")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングエラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय संबंधी त्रुटियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erros de temporização")
	return /** @type {LocalizedString} */ ("Timing Errors")
});